export default "__VITE_ASSET__Bf3X9CbG__"